import { PropsWithChildren } from 'react';

import { Box } from '@mui/material';

import { useTabsState } from './useTabsState';

export type TabContentProps<Value extends string = string> = PropsWithChildren<{
  value: Value;
  /**
   * Keeps the content of the tab in the DOM using display: none when the tab is inactive.
   * Useful when you need to maintain tab state while switching between tabs.
   */
  renderInactive?: boolean;
}>;

export const TabContent = <Value extends string>({
  value,
  children,
  renderInactive,
}: TabContentProps<Value>) => {
  const context = useTabsState();
  if (!context) {
    console.error('TabContent works only with TabsProvider');
    return null;
  }
  const { currentTab } = context;
  const isActive = currentTab === value;

  if (renderInactive) {
    return <Box display={isActive ? 'contents' : 'none'}>{children}</Box>;
  }

  if (!isActive) {
    return null;
  }

  return children;
};
